import _ from 'underscore';
import React, { useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DefaultButton } from '@fluentui/react';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

import { getCopyTagStyle } from '../styles/copy-tag-styles';
import { generateTag } from '../utils/tag-generator';

const CopyTagUnstyled = (props) => {
  const {
    tag,
    classes,
    onCopyCallback,
    platformName,
  } = props;
  const {
    id,
    type,
  } = tag;
  const i18n = useContext(I18nContext);
  const permissions = useContext(PermissionsContext);
  const isUetSpaTrackingEnabled = _.result(permissions.dynamic, 'UetAutoSpaTracking');

  const tagContent = useMemo(() =>
    generateTag(type, id, true, platformName, isUetSpaTrackingEnabled), [type, id, platformName, isUetSpaTrackingEnabled]);

  const copyTagToClipboard = useCallback(() => {
    navigator.clipboard.writeText(tagContent)
      .then(() => {
        onCopyCallback({
          error: null,
          message: i18n.getString(_TL_('Tag copied!')),
          tag: tagContent,
        });
      })
      .catch((err) => {
        onCopyCallback({
          error: typeof err === 'object' ? JSON.stringify(err) : err,
          message: i18n.getString(_TL_('Tag copied failed!')),
          tag: tagContent,
        });
      });
  }, [tagContent, onCopyCallback, i18n]);

  return (
    <div className={classNames(classes.container, 'copy-tag')}>
      <DefaultButton onClick={copyTagToClipboard} text={i18n.getString(_TL_('Copy tag'))} />
    </div>
  );
};

CopyTagUnstyled.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['Container', 'UET']).isRequired,
  }).isRequired,
  onCopyCallback: PropTypes.func.isRequired,
  classes: PropTypes.shape(_.mapObject(
    getCopyTagStyle(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  platformName: PropTypes.string,
};

CopyTagUnstyled.defaultProps = {
  platformName: undefined,
};

export const CopyTag = withDefaultStyles(CopyTagUnstyled, getCopyTagStyle);
